<template>
  <v-navigation-drawer :mini-variant="miniSidebar" app="app" clipped="clipped">
    <v-list>
      <template v-for="({ icon, label, to, group, children, key }, i) in menu">
        <v-list-item :to="to" @click="active = key" exact-active-class="router-link-exact-active" v-if="!children" :key="i">
          <v-list-item-action>
            <div class="icon" :class="`is-${icon}`"></div>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-if="children" @click="active = key" :key="i" :value="active == key">
          <template v-slot:activator>
            <router-link class="d-flex align-center group-active has-no-underline has-color-inherit" :to="to">
              <v-list-item-action>
                <div class="icon" :class="`is-${icon}`"></div>
              </v-list-item-action>
              <v-list-item-title>{{ label }}</v-list-item-title>
            </router-link>
          </template>
          <v-list-item :to="to" exact-active-class="router-link-exact-active" v-for="({ icon, label, to }, j) in children" :key="j">
            <v-list-item-action>
              <div class="icon" :class="`is-${icon}`"></div>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    miniSidebar: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: 'dashboard'
    }
  },
  computed: {
    menu () {
      return [
        { icon: 'dashboard', label: this.$t('navigation.dashboard'), to: '/', key: 'dashboard' },
        {
          icon: 'service-base',
          label: this.$t('navigation.serviceBase'),
          to: '/service-base/mapping',
          key: 'serviceBase',
          children: [
            { label: this.$t('navigation.mapping'), to: '/service-base/mapping' },
            { label: this.$t('navigation.site'), to: '/service-base/site-management' }
          ]
        },
        {
          icon: 'rentals',
          label: this.$t('navigation.rentals'),
          to: '/rentals',
          key: 'rentals',
          children: [
            { label: this.$t('navigation.appointment'), to: '/rentals/appointment' },
            { label: this.$t('navigation.history'), to: '/rentals/history' }
          ]
        },
        { icon: 'bikes', label: this.$t('navigation.bikes'), to: '/bikes', key: 'bikes' },
        {
          icon: 'maintenance',
          label: this.$t('navigation.maintenance'),
          to: '/maintenance',
          key: 'maintenance',
          children: [
            { label: this.$t('navigation.repairing'), to: '/maintenance/repairing' },
            { label: this.$t('navigation.detecting'), to: '/maintenance/detecting' },
            { label: this.$t('navigation.accessories'), to: '/maintenance/accessories' }
          ]
        },
        { icon: 'members', label: this.$t('navigation.members'), to: '/members', key: 'members' },
        { icon: 'analytics', label: this.$t('navigation.analytics'), to: '/analytics', key: 'analytics' },
        { icon: 'crm', label: this.$t('navigation.crm'), to: '/crm', key: 'crm' },
        { icon: 'activity', label: this.$t('navigation.activity'), to: '/activity', key: 'activity' },
        { icon: 'settings', label: this.$t('navigation.settings'), to: '/settings', key: 'settings' }
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
  .icon
    $szie= 20px
    width $szie
    height $szie
    background-size contain
    background-position center
    background-repeat no-repeat

    $icons= 'dashboard' 'service-base' 'rentals' 'bikes' 'maintenance' 'members' 'analytics' 'crm' 'activity' 'settings'
    for $icon in $icons
      &.is-{$icon}
        $path = '~@/assets/images/icons/' + $icon + '.svg'
        background-image url($path)

        .router-link-exact-active &/deep/
          $path = '~@/assets/images/icons/' + $icon + '-a.svg'
          background-image url($path)

  .group-active
    flex-grow 1
    flex-basis auto
    display flex

  .router-link-exact-active
    &/deep/ .v-list-item__content
      color $primary
</style>
